import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DesktopProjectModule } from '../project/desktop-project.module';

import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';
import { MiscModule } from 'projects/core/src/public-api';
import { MainViewComponent } from './main-view/main-view.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { KanbanCardComponent } from './main-view/kanban-card/kanban-card.component';
import { KanbanColumnComponent } from './main-view/kanban-column/kanban-column.component';
import { ProjectModule } from 'projects/mobile/src/app/modules/project/project.module';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { BoardFilterButtonComponent } from './main-view/board-filter-button/board-filter-button.component';
import { KanbanToolsComponent } from './main-view/kanban-tools/kanban-tools.component';
import { KanbanBoardComponent } from './main-view/kanban-board/kanban-board.component';
import { ManagersFilterComponent } from './main-view/board-filter-button/managers-filter/managers-filter.component';
import { ColumnsFilterComponent } from './main-view/board-filter-button/columns-filter/columns-filter.component';
import { PaymentStatusFilterComponent } from './main-view/board-filter-button/payment-status-filter/payment-status-filter.component';
import { CustomersFilterComponent } from './main-view/board-filter-button/customers-filter/customers-filter.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
// import { DragScrollModule } from 'ngx-drag-scroll';

@NgModule({
    declarations: [
        MainViewComponent,
        KanbanCardComponent,
        KanbanColumnComponent,
        BoardFilterButtonComponent,
        KanbanToolsComponent,
        KanbanBoardComponent,
        ManagersFilterComponent,
        ColumnsFilterComponent,
        PaymentStatusFilterComponent,
        CustomersFilterComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        MiscModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        ButtonModule,
        MatButtonModule,
        MatRippleModule,
        MatIconModule,
        MatDialogModule,
        OverlayPanelModule,
        CheckboxModule,
        MultiSelectModule,
        ProjectModule,
        ScrollingModule,
        // DragScrollModule,
        DesktopProjectModule
    ],
    exports: [MainViewComponent]
})
export class KanbanBoardModule { }
